export const employeesList = [
  "John Heart",
  "Samantha Bright",
  "Arthur Miller",
  "Robert Reagan",
  "Greta Sims",
  "Brett Wade",
  "Sandra Johnson",
  "Ed Holmes",
  "Barb Banks",
  "Kevin Carter",
  "Cindy Stanwick",
  "Sammy Hill",
  "Davey Jones",
  "Victor Norris",
  "Mary Stern",
  "Robin Cosworth",
  "Kelly Rodriguez",
  "James Anderson",
  "Antony Remmen",
  "Olivia Peyton",
  "Taylor Riley",
  "Amelia Harper",
  "Wally Hobbs",
  "Brad Jameson",
  "Karen Goodson",
  "Marcus Orbison",
  "Sandy Bright",
  "Morgan Kennedy",
  "Violet Bailey",
  "Ken Samuelson",
  "Nat Maguiree",
  "Bart Arnaz",
  "Leah Simpson",
  "Arnie Schwartz",
  "Billy Zimmer",
  "Samantha Piper",
  "Maggie Boxter",
  "Terry Bradley",
  "Gabe Jones",
  "Lucy Ball",
  "Jim Packard",
  "Hannah Brookly",
  "Harv Mudd",
  "Clark Morgan",
  "Todd Hoffman",
  "Jackie Garmin",
  "Lincoln Bartlett",
  "Brad Farkus",
  "Jenny Hobbs",
  "Dallas Lou",
  "Stu Pizaro",
];

export const employeesTasks = [
  {
    ID: 1,
    Assigned: "Mr. John Heart",
    BirthDate: "1964/03/16",
    Subject: "Choose between PPO and HMO Health Plan",
  },
  {
    ID: 2,
    Assigned: "Mr. John Heart",
    BirthDate: "1964/03/16",
    Subject: "Google AdWords Strategy",
  },
  {
    ID: 3,
    Assigned: "Mr. John Heart",
    BirthDate: "1964/03/16",
    Subject: "New Brochures",
  },
  {
    ID: 4,
    Assigned: "Mr. John Heart",
    BirthDate: "1964/03/16",
    Subject: "Update NDA Agreement",
  },
  {
    ID: 5,
    Assigned: "Mr. John Heart",
    BirthDate: "1964/03/16",
    Subject: "Review Product Recall Report by Engineering Team",
  },
  {
    ID: 6,
    Assigned: "Mrs. Olivia Peyton",
    Subject: "Update Personnel Files",
  },
  {
    ID: 7,
    Assigned: "Mrs. Olivia Peyton",
    Subject: "Review Health Insurance Options Under the Affordable Care Act",
  },
  {
    ID: 8,
    Assigned: "Mrs. Olivia Peyton",
    Subject: "Non-Compete Agreements",
  },
  {
    ID: 9,
    Assigned: "Mrs. Olivia Peyton",
    Subject: "Give Final Approval for Refunds",
  },
  {
    ID: 10,
    Assigned: "Mr. Robert Reagan",
    Subject: "Deliver R&D Plans for 2013",
  },
  {
    ID: 11,
    Assigned: "Mr. Robert Reagan",
    Subject: "Decide on Mobile Devices to Use in the Field",
  },
  {
    ID: 12,
    Assigned: "Mr. Robert Reagan",
    Subject: "Try New Touch-Enabled WinForms Apps",
  },
  {
    ID: 13,
    Assigned: "Mr. Robert Reagan",
    Subject: "Approval on Converting to New HDMI Specification",
  },
  {
    ID: 14,
    Assigned: "Ms. Greta Sims",
    Subject: "Approve Hiring of John Jeffers",
  },
  {
    ID: 15,
    Assigned: "Ms. Greta Sims",
    Subject: "Update Employee Files with New NDA",
  },
  {
    ID: 16,
    Assigned: "Ms. Greta Sims",
    Subject: "Provide New Health Insurance Docs",
  },
];
